// Képices : affiche ou masque « Me prévenir du retour » quand la variante change (sans rechargement).
if (!window.kepicesBackInStock && typeof subscribe === 'function') {
  window.kepicesBackInStock = true;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const box = document.querySelector(`.kbis[data-section="${data.sectionId}"]`);
    if (!box || !data.variant) return;

    box.classList.toggle('is-active', !data.variant.available);
    box.classList.remove('is-posted');

    const format = box.querySelector('[data-kbis-variant]');
    if (format) format.value = data.variant.title;
    const link = box.querySelector('[data-kbis-link]');
    if (link) link.value = `${link.dataset.kbisLink}?variant=${data.variant.id}`;
  });
}
